// Define your own error type
export default class UnauthenticatedError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "UnauthenticatedError";
	}
}

export function isUnauthenticatedError(error: unknown): error is UnauthenticatedError {
	return typeof (error as { name?: unknown })?.name === "string" && (error as { name: string }).name === "UnauthenticatedError";
}
